import { client } from "./client";

// 공지 CRUD 는 common-lib(getNotices/getNoticeDetail/addNotice/editNotice/deleteNotice)에 있다.
// 여기에는 common-lib 에 없는 본문 이미지 관련 호출만 둔다.
const baseUrl = "/notice";

// 공지 본문 이미지 업로드 → 저장된 이미지의 상대경로 URL 반환
export const uploadNoticeImage = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("image", file);
  const response = await client.post(`${baseUrl}/image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.url; // 예: "/uploads/notice/171234-abc.png"
};

// 미사용(미저장) 업로드 이미지 정리 — 취소/저장 시 호출
// 백엔드가 "어떤 공지에도 참조되지 않은" 파일만 지우므로 안전하다.
export const cleanupNoticeImages = async (images: string[]) => {
  if (!images?.length) return;
  try {
    await client.post(`${baseUrl}/image/cleanup`, { images });
  } catch (error) {
    // 정리는 부가 작업이므로 실패해도 화면 흐름을 막지 않는다.
    console.error("공지 이미지 정리 실패:", error);
  }
};
